import { ApiRef, createApiRef } from '@backstage/frontend-plugin-api';
import type { HandlersGraphEngineInternalResponse } from './graph-engine-api-sdk';

export type GraphEngine = HandlersGraphEngineInternalResponse;

export type GraphEngineRow = GraphEngine &
  Record<string, unknown> & {
    appliedNeo4jVersion?: string;
    displayCreatedAt?: Date;
    isDeleted?: boolean;
    state?: string;
  };

export interface GraphEngineApi {
  listGraphEngines(showDeleted: boolean): Promise<GraphEngine[]>;
  getGraphEngine(id: string): Promise<GraphEngine>;
  patchGraphEngineInternal(
    id: string,
    body: { memory?: string; neo4jVersion?: string },
  ): Promise<void>;
  patchGraphEnginesInternal(body: {
    ids: string[];
    memory?: string;
    neo4jVersion?: string;
  }): Promise<PatchGraphEnginesResult>;
}

export type PatchGraphEngineResult = {
  id: string;
  success: boolean;
  error?: string;
};

export type PatchGraphEnginesResult = {
  results: PatchGraphEngineResult[];
};

export const graphEngineApiRef: ApiRef<GraphEngineApi> =
  createApiRef<GraphEngineApi>({
    id: 'plugin.neo4j-graph-engine.service',
  });
